






































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaymentReceiptResponse } from '@/models/payment/payment.response';
import { NotificationHelper as _notification } from '@/helper/notifications.helper';
import { Base } from '@/components/common/base';
import {paymentService} from '@/shared';

@Component({
    computed: {
    },
})

export default class DealPaymentResponsePage extends Base {
    public loading: boolean = false;
    public txHeaderId: string = '';
    public txDetailId: string = '';
    public TransactionSetupID: string = '';
    public paymentResponse: PaymentReceiptResponse = {};
    public mounted() {
        this.txHeaderId = this.$route.query.txHeaderId as string;
        this.txDetailId = this.$route.query.txDetailId as string;
        if (this.txHeaderId && this.txDetailId) {
            this.getPaymentStatus(this.txHeaderId, this.txDetailId);
        } else {
            this.showAlert(false, this.$t('dealPaymentResponse.alertTransactionIdEmpty'));
        }
    }

    public async getPaymentStatus(txHeaderId: string, txDetailId: string): Promise<void> {
        try {
            this.loading = true;
            const payment = await paymentService.getResponse(txHeaderId, txDetailId);
            this.paymentResponse = payment;
            if (
    this.paymentResponse.paymentDetail.status === 'Approved' ||
    this.paymentResponse.paymentDetail.status === 'PartialApproved'
  ) {
    // tslint:disable-next-line:max-line-length
    this.showAlert(true, this.$t('roPaymentResponse.alertPaymentSuccess'));
  } else {
    if (this.paymentResponse.paymentDetail.status != 'Pending') {
      this.showAlert(true, payment.paymentDetail.status);
    }
  }
        } finally {
            this.loading = false;
        }
    }
}
